<template>
    <div class="p-3">
        <form-modal
            id="selic"
            placeholder-button="Inserir" 

            title-modal="Taxa selic"

            :fields="colunas"
            :values="dados"

            ref="modalForm"

            
            read
            update
            remove

            controles

            @ok="salvar"
            @edit="editar"
            @remove="deletar"
            @cancel="fechar"
        >
            <template #modal>                
                <modal :form="form" ref="modal" />
            </template>

            <template #table>
                <div>
                    <filtro ref="filtro" @buscar="buscar" @adicionar="adicionar" :btn="permissao.c"/>
                            
                    <b-table
                        @row-dblclicked="editar"
                        head-variant="dark"
                        :fields="colunas"
                        :items="dados"
                    >
                        <template #cell(actions)="data">
                            <div class="d-flex">
                                <b-button v-if="permissao.u" @click="editar(data.item)" variant="flat-primary">
                                    <i class="fas fa-edit"></i>
                                </b-button>
                                <b-button v-if="permissao.d" @click="deletar(data.item)" variant="flat-danger">
                                    <i class="fas fa-trash"></i>
                                </b-button>
                            </div>
                        </template>
                    </b-table>
                </div>
            </template>
        </form-modal>
    </div>
</template>
<script>
import FormModal from "@/components/modal/FormModal";
import cloneDeep from "lodash/cloneDeep";
import MovimentacaoFinanceiraService from "@/common/services/movimentacao_financeira/movimentacao_financeira.service";
import {AlertasMixin} from "@/common/mixins/AlertasMixin";
import helpers from "@/common/utils/helpers";
import { START_LOADING, STOP_LOADING } from "@/store/Store";
import Modal from "./modal";
import Filtro from "../Filtro";
export default {
    mixins: [AlertasMixin],
    components: {
        FormModal,
        Modal,
        Filtro
    },
    props: {
        empresaId: {
            type: String,
            required: true
        },
    },
    data: () => ({
        form : {
            ano: "",
            mes: "",
            taxa: 0,
        },
        colunas : [
            {key : "ano", label : "Ano"},
            {key : "mes", label : "Mês"},
            {key : "taxa", label : "Taxa SELIC (%)"},            
            {key : "actions", label : "Ações"},
        ],
         
        dados : [],
       
    }),
    mounted(){
        //this.buscar();
    },
    methods : {
        fechar : function(){
            this.$refs['filtro'].buscar();

            this.form = {
                ano: "",
                mes: "",
                taxa: 0,
            };

        },
        adicionar : function(){
            this.$refs.modalForm.openModal();
        },
        montar : function(){
            this.mesInicio = null;
            this.mesFim = null;
            this.anoFim = null;
            this.intervalo = 'ano';
            this.$refs['filtro'].montar();
        },
        salvar : function(){
            let form = cloneDeep(this.form);
            if(!this.$refs.modal.validateState())
                return;

            this.confirmar('Aviso','Deseja salvar?').then(confirmado => {
                if(confirmado){

                    form.EmpresaId = this.empresaId;

                    this.$store.dispatch(START_LOADING);
                    MovimentacaoFinanceiraService.salvarSelic(form).then(() => {
                        this.alertaSucesso('Salvo com sucesso!').then(() => {
                            this.$refs.modalForm.closeModal();
                            this.$refs['filtro'].buscar();
                        });
                    }).catch(err => {
                         if(err.response.status == 400){
                            this.alertaErro(err.response.data.errors);
                        }else   
                            this.alertaErro("Erro ao salvar");
                    }).finally(() => {
                        this.$store.dispatch(STOP_LOADING);
                    });
                }
            })
        },

        deletar : function(item){
            this.confirmar('Aviso','Deseja realmente excluir?').then(confirmado => {
                if(confirmado){

                    this.$store.dispatch(START_LOADING);
                    MovimentacaoFinanceiraService.deletarSelic(item.id).then(() => {
                        this.alertaSucesso('Excluído com sucesso!');
                        this.$refs['filtro'].buscar();
                    }).catch(err => {
                         if(err.response.status == 400){
                            this.alertaErro(err.response.data.errors);
                        }else   
                            this.alertaErro("Erro ao excluir");
                    }).finally(() => {
                        this.$store.dispatch(STOP_LOADING);
                    });
                }
            })
        },

        editar : function(item){
            let form = cloneDeep(item);
            this.form = form;
            this.form.mes = helpers.retornarMeses().find(mes => mes.enum == this.form.mes).value;
            this.$refs.modalForm.openModal();
        },

        buscar : function(filtro){
            this.$store.dispatch(START_LOADING);
            MovimentacaoFinanceiraService.listarSelic(this.empresaId,  filtro.ano, filtro.anoFim, filtro.mesInicio, filtro.mesFim).then(response => {
                this.dados = response.data.data;
            }).catch(() => {
                this.alertaErro("Erro ao buscar");
            }).finally(() => {
                this.$store.dispatch(STOP_LOADING);
            });
        },
    },
    computed : {
        permissao() {
            return this.$store.getters['app/retornaPermissao']('MovimentacaoFinanceiraSelic');
        }
    }
}
</script>
<style lang="">
    
</style>